import React, { useState } from 'react'
import classNames from 'classnames'
import AskVisoGrid from '../layout/AskVisoGrid'
import ModalCheckbox from 'components/ModalCheckbox'
import AskVisoThinking from '../layout/AskVisoThinking'
import { filterByDateRange } from '../../utils'
import { handleMutation } from 'utils/request'
import { defaultNotifier } from 'functions/notificationHandler'
import { deleteConversation } from 'api/ai-agents'
import './AskVisoHistory.scss'

const AskVisoHistory = ({ color, data, onConversationClick, isLoading, getHistory, isFullscreen }) => {
  const [deleteModal, setDeleteModal] = useState('')
  const [deleteLoading, toggleDeleteLoading] = useState(false)
  const { today, yesterday, previous7Days, previous30Days, older } = filterByDateRange(data)
  const commonProps = {
    onDeleteClick: (id) => setDeleteModal(id),
    onConversationClick,
    color,
    deleteLoading,
    isFullscreen
  }

  const onDeleteConversation = async (conversationId) => {
    toggleDeleteLoading(true)
    const onSuccess = () => {
      defaultNotifier('Conversation deleted successfully')
      getHistory()
    }

    try {
      const response = await deleteConversation({ id: conversationId })
      handleMutation(response, onSuccess)
    } catch (error) {
      defaultNotifier(error)
    } finally {
      setDeleteModal('')
      toggleDeleteLoading(false)
    }
  }

  return (
    <div className={classNames('ask-viso-history', isFullscreen && 'ask-viso-history--fullscreen')}>
      {isLoading ?
          <AskVisoThinking color={color} />
        :
        <>
          {today.length > 0 && <AskVisoGrid data={today} {...commonProps} title='Today' />}
          {yesterday.length > 0 && <AskVisoGrid data={yesterday} {...commonProps} title='Yesterday' />}
          {previous7Days.length > 0 && <AskVisoGrid data={previous7Days} {...commonProps} title='Previous 7 days' />}
          {previous30Days.length > 0 && <AskVisoGrid data={previous30Days} {...commonProps} title='Previous 30 days' />}
          {older.length > 0 && <AskVisoGrid data={older} {...commonProps} title='Older' />}
        </>
      }
      {deleteModal &&
        <ModalCheckbox
          title='Remove Conversation'
          color={color}
          confirmMessage='You are about to permanently remove this conversation.'
          onClose={() => setDeleteModal('')}
          onConfirm={deleteModal ? () => onDeleteConversation(deleteModal) : null}
          hideCheckBox
          confirmText='Delete'
          confirmColor='danger'
        />
      }
    </div>
  )
}

export default AskVisoHistory